import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PoultryItem } from "../types";

interface RestockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedItem: PoultryItem | null;
  restockQuantity: string;
  onQuantityChange: (value: string) => void;
  onConfirm: () => void;
}

export const RestockDialog = ({
  open,
  onOpenChange,
  selectedItem,
  restockQuantity,
  onQuantityChange,
  onConfirm,
}: RestockDialogProps) => {
  if (!selectedItem) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            Réapprovisionnement - {selectedItem.data.Race || selectedItem.data.name}
          </DialogTitle>
          <DialogDescription>
            Ajoutez la quantité que vous souhaitez ajouter au stock.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label
              htmlFor="quantity"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Quantité à ajouter
            </label>
            <Input
              id="quantity"
              type="number"
              value={restockQuantity}
              onChange={(e) => onQuantityChange(e.target.value)}
              placeholder="Entrez la quantité"
              min="1"
            />
            <p className="text-sm text-muted-foreground">
              Stock actuel: {selectedItem.quantity} {selectedItem.data.unit || 'unités'}
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button 
            onClick={onConfirm}
            disabled={!restockQuantity || parseInt(restockQuantity) <= 0}
          >
            Confirmer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};